/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ attr: NonNullable<unknown> }} Auto_DescriptionInputs */

const fr_auto_description = /** @type {(inputs: Auto_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ajoutez le widget via ${i?.attr} :`)
};

const en_auto_description = /** @type {(inputs: Auto_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add the widget via ${i?.attr}:`)
};

/**
* | output |
* | --- |
* | "Add the widget via {attr}:" |
*
* @param {Auto_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const auto_description = /** @type {((inputs: Auto_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auto_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_auto_description(inputs)
	return en_auto_description(inputs)
});